// extracted by mini-css-extract-plugin
export default {"main":"ButtonShare_main__G-fgi","icon":"ButtonShare_icon__gOm3U"};